import React from "react";
import { View, Text, Image } from "react-native";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { AppColors } from "../../utility/AppColors";
import { AppImages } from "../../utility/AppImages";

const TicketDetail = () => {
  return (
    <>
      <View style={{ gap: 8 }}>
        <Text style={[AppFontStyle.MEDIUM_ANYBODY_14]}>Streaming Cost</Text>
        <View
          style={{
            backgroundColor: AppColors.purple_453B50,
            borderRadius: 10,
            paddingHorizontal: 5,
            paddingVertical: 15,
          }}
        >
          <View
            style={{
              backgroundColor: AppColors.black_18151b,
              borderRadius: 10,
              justifyContent: "space-between",
              flexDirection: "row",
              alignItems: "center",
              padding: 12,
            }}
          >
            <Text style={[AppFontStyle.BOLD_ANYBODY_20, { fontWeight: 700 }]}>
              $<Text style={AppFontStyle.BOLD_ANYBODY_26}>00</Text>
            </Text>
            <View
              style={{ flexDirection: "row", gap: 5, alignItems: "center" }}
            >
              <Image
                source={AppImages.icTokenKo}
                style={{
                  height: 18,
                  width: 18,
                  resizeMode: "contain",
                }}
              />
              <Text style={[AppFontStyle.BOLD_ANYBODY_26, { fontWeight: 700 }]}>
                00
              </Text>
            </View>
          </View>
        </View>
      </View>
      <View style={{ gap: 8 }}>
        <Text style={[AppFontStyle.MEDIUM_ANYBODY_14]}>
          Minimum ticket price for audience tickets
        </Text>
        <View
          style={{
            backgroundColor: AppColors.purple_453B50,
            borderRadius: 10,
            paddingHorizontal: 5,
            paddingVertical: 15,
          }}
        >
          <View
            style={{
              backgroundColor: AppColors.black_18151b,
              borderRadius: 10,
              justifyContent: "space-between",
              flexDirection: "row",
              alignItems: "center",
              padding: 12,
            }}
          >
            <Text style={[AppFontStyle.BOLD_ANYBODY_20, { fontWeight: 700 }]}>
              $<Text style={AppFontStyle.BOLD_ANYBODY_26}>00</Text>
            </Text>
            <View
              style={{ flexDirection: "row", gap: 5, alignItems: "center" }}
            >
              <Image
                source={AppImages.icTokenKo}
                style={{
                  height: 18,
                  width: 18,
                  resizeMode: "contain",
                }}
              />
              <Text style={[AppFontStyle.BOLD_ANYBODY_26, { fontWeight: 700 }]}>
                00
              </Text>
            </View>
          </View>
        </View>
      </View>
    </>
  );
};

export default TicketDetail;
